import React from 'react'
import styles from './about.module.css'

export default function About() {
  return (
    <div id={styles.about}>
      
      {/* <div id={styles.me}>
        <img src="/me.png" alt="Picture of Tenadi Karuwo" />
      </div> */}

      <div id={styles.aboutContainer}>
        {/* <div id={styles.mobMe}>
        <img src="/me.png" alt="Picture of Tenadi Karuwo" />
      </div> */}
        
       <p>
    I'm Tendai, a Full-Stack Developer who builds modern, user-centred applications with a strong focus on clean
    architecture, intuitive design, and reliable backend systems. My journey into tech began after studying
    <strong> Medicinal and Pharmaceutical Chemistry</strong> and working as a Sterile Specialist, where precision, structure,
    and problem-solving were essential. Those same qualities now shape the way I approach software development.
  </p>
  <p>
    What started as curiosity during the pandemic grew into a full career transition. I trained at the
    <strong> School of Code</strong>, strengthened my skills through real-world projects, and continue to deepen my knowledge
    through the <strong>Meta Full-Stack Developer</strong> programme. Staying up to date with emerging tools and best practices
    is important to me, and I'm always building new projects to reinforce and expand my existing skills.
  </p>
  <p>
    I work confidently across the stack using <strong>React, TypeScript, Node.js, PostgreSQL</strong>, and a strong
    suite of testing tools including <strong>Jest, SuperTest, Cypress, and Playwright</strong>. I enjoy turning ideas into
    polished digital experiences—whether that's designing intuitive interfaces, building scalable backend services, or
    ensuring reliability through thoughtful testing.
  </p>
  <p>
    My portfolio highlights a selection of the projects I've built, including long-term work like
    <em> Lucid Clothing</em>, which has helped me master authentication, state management, routing, and real-world application
    structure. These are just a few examples of what I've created. If you'd like to explore more of my work or dive deeper
    into any project, I'd be more than happy to share.
  </p>
  <p>
    I'm driven by curiosity, continuous improvement, and the desire to build software that feels purposeful, accessible,
    and enjoyable to use.
  </p>

      </div>
    </div>
  );
}
